import { text } from './atom.text.style.js';
import { useMaximumDropzoneTextLength } from './context.js';
import { jsx } from 'react/jsx-runtime';

function TextContent(props) {
  const widestText = useMaximumDropzoneTextLength();
  return /*#__PURE__*/jsx("span", {
    className: text,
    "data-wide": widestText >= 50,
    children: props.text
  });
}

export { TextContent };
//# sourceMappingURL=atom.text.js.map
